import { useTranslation } from "react-i18next";
import { useText } from "../context/ContentContext";

export default function About() {
  const { t } = useTranslation();
  const p1 = useText("about_p1", "about.p1");
  const p2 = useText("about_p2", "about.p2");
  const p3 = useText("about_p3", "about.p3");
  return (
    <div data-testid="about-page" className="pt-32 md:pt-40 pb-24">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12">
        <div className="overline mb-5">{t("about.overline")}</div>
        <h1 className="font-serif text-5xl md:text-8xl text-[#F5F5F0] leading-[0.9] mb-16">
          {t("about.title_1")} <br />
          <em className="text-[#D4AF37] not-italic">{t("about.title_2")}</em>, <br />
          {t("about.title_3")}
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-20">
          <div className="md:col-span-7 space-y-6 text-lg text-[#F5F5F0] leading-relaxed font-light">
            <p>{t("about.p1")}</p>
            <p className="text-[#A3A39D]">{t("about.p2")}</p>
            <p className="text-[#A3A39D]">{t("about.p3")}</p>
          </div>
          <div className="md:col-span-5 md:pl-10 border-l border-white/10">
            <div className="overline mb-5 text-[10px]">{t("about.values")}</div>
            <ul className="space-y-5 text-sm text-[#A3A39D]">
              <li><div className="text-[#F5F5F0] mb-1">{t("about.v1")}</div>{t("about.v1d")}</li>
              <li><div className="text-[#F5F5F0] mb-1">{t("about.v2")}</div>{t("about.v2d")}</li>
              <li><div className="text-[#F5F5F0] mb-1">{t("about.v3")}</div>{t("about.v3d")}</li>
              <li><div className="text-[#F5F5F0] mb-1">{t("about.v4")}</div>{t("about.v4d")}</li>
            </ul>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-white/10 pt-16">
          <Stat num="14" label={t("about.s1")} />
          <Stat num="9" label={t("about.s2")} />
          <Stat num="420+" label={t("about.s3")} />
          <Stat num="2019" label={t("about.s4")} />
        </div>
      </div>
    </div>
  );
}

function Stat({ num, label }) {
  return (
    <div>
      <div className="font-serif text-5xl md:text-6xl text-[#D4AF37] mb-3">{num}</div>
      <div className="overline text-[10px]">{label}</div>
    </div>
  );
}
